import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { ArrayHelper } from 'src/app/models/helpers/array-helper';
import { ModalAddTreeSpeciesComponent } from './modals/add-tree-species.component';
export class TreeSpeciesComponent {
    constructor(treeSpeciesService, _modalService, route, router, appConfigService) {
        this.treeSpeciesService = treeSpeciesService;
        this._modalService = _modalService;
        this.route = route;
        this.router = router;
        this.appConfigService = appConfigService;
        this.treeSpecies = {};
        this.columns = [
            { title: 'Species Name', property: c => c.species, canSort: true },
            { title: 'Description', property: c => c.description },
            { title: 'Image', property: c => c.photoUrl }
        ];
        this.ModalType = {
            add: 'add',
            edit: 'edit'
        };
        this.copied = false;
        this.scrollConfig = {
            suppressScrollX: false,
            suppressScrollY: true
        };
        this.sortColumn = this.columns[0];
        this.sortAsc = true;
        this.page = 1;
        this.config = {
            suppressScrollX: false, suppressScrollY: true
        };
    }
    ngOnInit() {
        this.pageSize = this.appConfigService.treeSpecieListPageSize;
        this.route.data.subscribe(data => {
            this.species = data.species || [];
            this.filterUpdated();
        });
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }
    filterUpdated() {
        let searchText = this.searchText ? this.searchText.toLowerCase() : '';
        this.filteredSpecies = this.species.filter(species => {
            if (searchText === '')
                return true;
            return (species.species && species.species.toLowerCase().includes(searchText));
        });
        this.sort();
    }
    sort(column) {
        if (column && !column.canSort)
            return;
        if (column === this.sortColumn)
            this.sortAsc = !this.sortAsc;
        if (column)
            this.sortColumn = column;
        this.filteredSpecies = ArrayHelper.sortBy(this.filteredSpecies, this.sortAsc, this.sortColumn.property);
        this.pageChange(this.page);
    }
    pageChange(page) {
        this.page = page;
        let start = this.pageSize * (page - 1);
        let end = this.pageSize * page;
        this.pageSpecies = this.filteredSpecies.slice(start, end);
    }
    updatePageSize() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.appConfigService.updateSpeciePageSize(this.pageSize);
            setTimeout(() => {
                this.page = 1;
                this.pageChange(this.page);
                this.filterUpdated();
            });
        });
    }
    openEditModal(type, specie) {
        this.treeSpecies = type == this.ModalType.edit ? Object.assign({}, specie) : {};
        const initialState = {
            speciesDto: this.speciesDto$,
            isEditSpecies: type == this.ModalType.edit,
            treeSpecies: this.treeSpecies,
        };
        this.modalRef = this._modalService.show(ModalAddTreeSpeciesComponent, {
            class: "modal-lg",
            initialState,
            keyboard: false,
        });
        this.modalRef.content.isSaved$.subscribe((value) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (value) {
                this.species = yield this.treeSpeciesService.getAllSpecies();
                this.filterUpdated();
            }
        }));
    }
    openDeleteModal(specieId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.currentSpecieId = specieId;
            this.plantingSiteList = yield this.treeSpeciesService.getPlantingSiteSpecies(this.currentSpecieId);
            this.deleteModal.show();
        });
    }
    confirmDelete() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.treeSpeciesService.deleteSpecies(this.currentSpecieId).then((res) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                this.deleteModal.hide();
                this.species = yield this.treeSpeciesService.getAllSpecies();
                this.filterUpdated();
            }));
        });
    }
    copyInputMessage(inputElement) {
        inputElement.select();
        document.execCommand('copy');
        inputElement.setSelectionRange(0, 0);
        this.copied = true;
        //wait 3 Seconds and hide copied
        setTimeout(function () {
            this.copied = false;
        }.bind(this), 3000);
    }
}
